import React from 'react';
import { Table as AntTable } from 'antd';

const compare = (a, b) => {
	if(a === null)
		a = typeof b == 'string' ? '' : 0;
	if(b === null)
		b = typeof a == 'string' ? '' : 0;
	if(typeof a == 'string' && typeof b == 'string') {
		return a.localeCompare(b);
	}
	else
		return a - b;
}

const Table = props => {
  const {
	columns,
	dataSource, // Important: Get the original data source
	onChange, // Important: Get the user's onChange handler (if any)
	onDataChange, // New custom prop for exposing the sorted data
	...otherTableProps
  } = props;

  const sortableColumns = columns.map(column => {
	const { sorter, dataIndex, sortDirections = ['ascend', 'descend', 'ascend'], ...otherColumnProps } = column;

	if (sorter) {

	  return {
		...otherColumnProps,
		dataIndex,
		sorter: {
		  compare: (rowA, rowB) => compare(rowA[dataIndex], rowB[dataIndex]),
		},
		sortDirections
	  };
	}

	return column;
  });
  
  const handleTableChange = (pagination, filters, sorter, extra) => {
	  // 1. Call the original onChange handler first
	  if (onChange) {
		  onChange(pagination, filters, sorter, extra);
	  }
  
	  // 2. Check if a sort action occurred and we have an onDataChange callback
	  if (onDataChange && sorter && sorter.order) {
		  const { field, order } = sorter;
  
		  // 3. Create a **copy** of the original data to sort it (avoid mutation)
		  const sortedData = [...dataSource].sort((rowA, rowB) => {
			  const comparisonResult = compare(rowA[field], rowB[field]);
  
			  // 4. Apply sort direction: ascend is default result, descend reverses it
			  return order === 'ascend' ? comparisonResult : -comparisonResult;
		  });
		  
		  // 5. Pass the final sorted data to the consumer
		  onDataChange(sortedData);
	  }
	  // Optional: Pass back the unfiltered/unsorted data if sorting is cleared
	  else if (onDataChange && sorter && !sorter.order) {
		   onDataChange(dataSource);
	  }
  };

  return (
	<AntTable
	  columns={sortableColumns}
	  dataSource={dataSource} // Ant Table uses this prop for display
	  onChange={handleTableChange} // Intercept
	  {...otherTableProps}
	/>
  );
};

export default Table;
